import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteOranSchema } from '@api/schemaConfig';

import { IDeleteOranSchemaDTO } from '@interfaces/cmModule/schemaConfig';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes } from '@enums/common';

import {
	MAVENIR_SCHEMA_CONFIG,
	SCHEMA_CONFIG_DELETE,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateSchemaDeleteOran(
	props?: IOnSuccess) {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const { onSuccess } = props || {};

	const {
		mutate: deleteOranSchemaConfig,
		isLoading: isLoadingDeleteOranSchemaConfig,
	} = useMutation<IDeleteOranSchemaDTO>({
		mutationKey: [SCHEMA_CONFIG_DELETE],
		mutationFn: deleteOranSchema,
		onSuccess: () => {
			if (onSuccess) onSuccess();

			dispatch(setSnackbar({
				message: responseMessages.deleteDataModelConfig,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG])];
		},
	});

	return {
		deleteOranSchemaConfig,
		isLoadingDeleteOranSchemaConfig,
	};
}
